import "core-js/modules/es6.string.fixed";
import "core-js/modules/es6.function.name";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import { asyncRouterMap, constantRoutes } from '@/router';

/**
 * 通过meta.role判断是否与当前用户权限匹配
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  return roles.includes(route.name);
}

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param asyncRouterMap
 * @param roles
 */
function filterAsyncRouter(asyncRouterMap, roles, role, account_type) {
  var accessedRouters = asyncRouterMap.filter(function (route) {
    if (account_type.includes(8)) {
      if (route.isAdmin) {
        return true;
      }
    }
    if (account_type.includes(16)) {
      //工作室审核员
      if (route.isStudioAdmin) {
        return true;
      }
    }
    if (account_type.includes(100) && !route.isAdmin) {
      //判断单位类型，某些菜单只有区领到能看到 
      return true;
    }
    if (route.fixed) {
      //固定在菜单栏，不受权限控制
      return true;
    }
    if (hasPermission(roles, route)) {
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children, roles, role, account_type);
      }
      return true;
    }
    return false;
  });
  return accessedRouters;
}
var permission = {
  state: {
    routers: constantRoutes,
    addRouters: []
  },
  mutations: {
    SET_ROUTERS: function SET_ROUTERS(state, routers) {
      state.addRouters = routers;
      state.routers = constantRoutes.concat(routers);
      console.log('state.routers', state.routers);
    }
  },
  actions: {
    GenerateRoutes: function GenerateRoutes(_ref, data) {
      var commit = _ref.commit;
      return new Promise(function (resolve) {
        var roles = data.roles,
          role = data.role,
          account_type = data.account_type;
        var accessedRouters = filterAsyncRouter(asyncRouterMap, roles, role, account_type);
        commit('SET_ROUTERS', accessedRouters);
        resolve();
      });
    }
  }
};
export default permission;